import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientProfileResponse } from "hvp-shared";

interface ClientAuthState {
  isLoading: boolean;
  isAuthenticated: boolean;
  client?: ClientProfileResponse;
  error?: string;
}

const initialState: ClientAuthState = {
  isLoading: true,
  isAuthenticated: false,
  client: undefined,
  error: undefined,
};

export const clientAuthSlice = createSlice({
  name: "clientAuth",
  initialState,
  reducers: {
    setClientLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    clientLoginSuccess: (state, action: PayloadAction<ClientProfileResponse>) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.client = action.payload;
      state.error = undefined;
    },
    clientLoginFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.error = action.payload;
    },
    clientLogout: (state) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.client = undefined;
      state.error = undefined;
    },
    updateClientProfile: (state, action: PayloadAction<ClientProfileResponse>) => {
      state.client = action.payload;
    },
    clearClientError: (state) => {
      state.error = undefined;
    },
  },
});

export const {
  setClientLoading,
  clientLoginSuccess,
  clientLoginFailure,
  clientLogout,
  updateClientProfile,
  clearClientError,
} = clientAuthSlice.actions;
